var SENTRY_RELEASE;SENTRY_RELEASE={name: "Per Diem", version: "1.4.2"};